/**
 * Import Lib & assets
 */

import React, { useContext } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

import { isProductFromZodiac, getAvis } from "helpers/zodiac";
import { ContentContext } from "context/contentContext";

/**
 * import components
 */

/**
 * styled components
 */

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  ${t.mixins.flex({ align: "flex-start" })}
  z-index: 4;
  padding: 100px 0;
`;

const Shadow = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${t.color.black};
  opacity: 0.7;
  z-index: 3;
`;
const Frame = styled.iframe`
  min-width: 90%;
  min-height: 100%;
  background-color: white;
`;
const Cross = styled.p`
  margin-bottom: 0;
  padding: 5px 7px;
  background-color: ${t.color.primary};
  font-family: "Arial", sans-serif;
  color: ${t.color.white};
  font-weight: ${t.font.bold};
  cursor: pointer;
`;

/**
 * popin component is..
 */

const Content__popin = ({ id, name, onClose }) => {
  const slug = name.trim().replace(/[ -]+/g, '-').toLowerCase();  
  const { lang } = useContext(ContentContext);
  const langSlug = {"fr": 'fr-FR', "es": 'es-ES', "de": 'de-DE', "it": 'it-IT'};  
  const campagnId = "62aa07e857272822f843b04c";
  const languageIds = {"fr": "62aa07de57272822f84390bc", 'es' : '62aa07de57272822f84390bf', 'de' : '62aa07de57272822f84390bd', 'it' : '62aa07de57272822f84390be'};
  const zodiacUrl = getAvis();
  const url = `${zodiacUrl}?campaignId=${campagnId}&languageId=${languageIds[lang]}&isBrandPopup=true&background_culture=${langSlug[lang]}&llt=${slug}`;
  return (
    <>
      <Shadow />
      <Container>
        <Frame src={url} />
        <Cross
          onClick={() => {
            onClose();
          }}
        >
          X
        </Cross>
      </Container>
    </>
  );
};

export default Content__popin;

Content__popin.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Content__popin.defaultProps = {
  style: {},
};

/*
    import Content__popin from 'components/content/popin/content__popin'
    <Content__popin />
  */
